import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'react-bootstrap';
import ErrorImg from './error-banner.svg';
import InfoImg from './info-banner.svg';
import WarningImg from './warning-banner.svg';
import './IcpFaceErrorBanner.scss';

/**
 * Floating Icp error control
 * @class IcpFaceErrorBanner
 * @extends {Component}
 */
class IcpFaceErrorBanner extends Component {
  state = { visible: true, };
  static propTypes = {
    /** Text of error message */
    messages: PropTypes.array,
    /** Amount of time to show the message */
    showDuration: PropTypes.number,
    /** Fade duration */
    fadeDuration: PropTypes.number,
    /** Whether the error box should be able to be dismissed by the user */
    dismissable: PropTypes.bool,
  };

  static defaultProps = {
    messages: ['Try again.',],
    showDuration: 10 * 1000,
    fadeDuration: 1000,
    dismissable: true,
  };

  bannerImages = {
    error: ErrorImg,
    warning: WarningImg,
    info: InfoImg,
  };

  componentDidMount() {
    if (this.props.showDuration > 0) {
      this.timeoutId = setTimeout(
        () => this.setState({ visible: false, }), this.props.showDuration
      );
    }
  };

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    return (
      <Fade in={this.state.visible}
        timeout={this.props.fadeDuration}
        unmountOnExit={true}
      >
        <div className={`header ${this.props.icpError.status || ''}`}>
          <div className='header-banner-container'>
            <div className='header-banner'>
              <div>
                <img src={this.bannerImages[this.props.icpError.status]} alt={this.props.icpError.status} />
              </div>
              <div className='header-banner-content'>
                <div className='header-banner-message'>{this.props.icpError.message}</div>
                {!!this.props.icpError.subMessage && <div className='header-banner-submessage'>{this.props.icpError.subMessage}</div>}
              </div>
            </div>
          </div>
        </div>
      </Fade>
    );
  }
}

export default IcpFaceErrorBanner;
